import { NotificationService } from 'app/core/services/notification.service';
import { PermissionsService } from 'app/core/services/permissions.service';
import { AmberApi } from 'app/core/models/api-helpers';
import { Observable, Subject, ReplaySubject } from 'rxjs/';
import { AccountService } from './../../account.service';
import { FormGroup, Validators, FormBuilder, FormControl, AbstractControl } from '@angular/forms';
import { RxComponent } from 'app/core/components/common/rx.component';
import { Component, OnInit, Input, ViewChild, SimpleChanges } from '@angular/core';

@Component({
    selector: 'itpx-update-smtp',
    templateUrl: './update-smtp.component.html',
    styleUrls: ['./update-smtp.component.css']
})
export class UpdateSmtpComponent extends RxComponent {

    @Input()
    private account: any;
    @Input()
    private cancelRoute: string;

    private smtp = new ReplaySubject<any>();
    private smtpForm: FormGroup;
    private passwordControl: AbstractControl;
    private currentEmail: string;
    private inEdit: boolean;

    @ViewChild('password') passwordDom: any;

    private formSubmit = new Subject<any>();

    private smtpTypes: Observable<any[]>;
    private selectedType: Observable<any>;

    constructor(
        private fb: FormBuilder,
        private service: AccountService,
        private permissionsService: PermissionsService,
        private notificationService: NotificationService
    ) {
        super();
    }

    ngOnChanges(change: SimpleChanges) {
        if (change['account']) {
            this.smtp.next(change['account'].currentValue.smtpDetails[0] || {});
        }
    }

    ngOnInit() {

        this.inEdit = !!this.smtp;
        
        this.smtpForm = this.fb.group({
            label: [null, Validators.required],
            isDefault: [null, Validators.required],
            type: this.fb.group({
                key: [null, Validators.required],
                value: [null]
            }),
            basicForm: this.fb.group({
                from: [null, Validators.required],
                host: [null, Validators.required],
                username: [null, Validators.required],
                password: [null],
                port: [null],
            })
        });

        this.smtp
            .bindToLifecycle(this)
            .subscribe(smtp => {
                let type = (smtp && smtp.type) ? smtp.type.configKey : null;
                this.smtpForm.patchValue({
                    label: smtp.label,
                    isDefault: smtp.isDefault,
                    type: {
                        key: smtp.type ? smtp.type.id : null,
                        value: smtp.type ? smtp.type.configValue : null
                    },
                    basicForm: {
                        from: smtp.from,
                        host: smtp.host,
                        username: smtp.username,
                        password: null,
                        port: smtp.port
                    }
                })
            });

        this.smtp
            .takeWhen(this.afterViewInit())
            .bindToLifecycle(this)
            .subscribe(_ => this.passwordControl.disable());

        let basicForm = this.smtpForm.controls.basicForm as FormGroup;
        this.passwordControl = basicForm.controls.password;

        this.smtpTypes = this.service.getSmtpTypes()
            .extract(AmberApi.Data)
            .neverError()
            .shareReplay();

        this.selectedType = this.smtpForm.controls.type.valueChanges
            .do(_ => console.log('type changed', _))
            .withLatestFrom(this.smtpTypes, (val, types) => types.find(t => t.key == val.key))
            .startWith(this.smtpForm.controls.type.value)
            .shareReplay();

        this.selectedType
            .withLatestFrom(this.smtp, (type, smtp) => ({smtp: smtp, type: type}))
            .bindToLifecycle(this)
            .subscribe(data => {
                let basicForm = this.smtpForm.controls.basicForm as FormGroup;
                data.type.value == 'Basic' ? basicForm.enable() : basicForm.disable();
                if (data.smtp.host) this.passwordControl.disable();
            });

        this.formSubmit
            .withLatestFrom(this.selectedType, (data, type) => ({ data: data, type: type }))
            .flatMap(d => d.type.value == 'Gmail' ?
                this.permissionsService.gmailSmtpPermissions().map(res => this.mapToGmailDto(d.data, res.code)).neverError() :
                Observable.of(d.data).map(data => this.mapToBasicDto(data))
            )
            .flatMap(data => this.service.updateSmtpDetails(this.account.id, data).neverError())
            .extract(AmberApi.Data)
            .bindToLifecycle(this)
            .subscribe(acc => {
                this.smtp.next(acc.smtpDetails[0]);
                this.notificationService.success('SMTP credentials successfully updated');
            });
    }

    private mapToGmailDto(formData: any, code: string): any {
        let dto = this.mapBaseProperties(formData);
        dto.authCode = code;
        return dto;
    }

    private mapToBasicDto(formData: any): any {
        let dto = this.mapBaseProperties(formData);
        dto.host = formData.basicForm.host;
        dto.username = formData.basicForm.username;
        dto.password = formData.basicForm.password;
        dto.from = formData.basicForm.from;
        dto.port = formData.basicForm.port;
        return dto;
    }

    private mapBaseProperties(formData: any): any {
        return {
            label: formData.label,
            isDefault: formData.isDefault,
            type: { id: formData.type.key }
        };
    }

    private onSubmit(data: any) {
        this.formSubmit.next(data);
    }

    private onPasswordClick() {
        this.passwordControl.enable();
        this.passwordDom.nativeElement.focus();
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/accounts/edit/update-smtp/update-smtp.component.ts